import { createTheme } from '@mui/material'

const theme = createTheme({
  palette: {
    background: { default: '#f0f2f5', paper: '#ffffff' },
    primary:    { main: '#1565c0', light: '#e3f2fd', dark: '#0d47a1' },
    divider:    '#e3e8ef',
    text:       { primary: '#1a2233', secondary: '#4a5568', disabled: '#8fa3bc' },
  },
  typography: { fontFamily: "'IBM Plex Sans', sans-serif" },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper:  { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCard:   { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1565c0' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1565c0',
            boxShadow: '0 0 0 3px rgba(21,101,192,.1)',
          },
        },
      },
    },
  },
})

export default theme
